<template>
    <div>
      <issue-item-modal-content
        v-if="item !== undefined"
        :item="item"
      />
    </div>
</template>

<script>

    import IssueItemModalContent from "./IssueItemModalContent";

    export default {
        name: "issue-item-modal" ,
        components : {
          IssueItemModalContent

        },
        props : ['item'],
        mounted () {
          document.getElementsByClassName('v--modal-box')[0].style.overflowY = 'scroll';
        },
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueItemModal.vue